import * as React from 'react';
// ***********************************
interface IProps {
  fill: string;
  size: number;
}
// ***********************************
export default class LoadingVector extends React.Component<IProps, {}> {
  //***********************
  render() {
    let {size}=this.props;
    let style={height: size,width: size};
    return (
      <svg fill={this.props.fill} xmlns="http://www.w3.org/2000/svg" style={style} height={size} width={size} viewBox="0 0 150 150">
        <text x="110.62603" y="135.09752" strokeWidth=".26458332" fontFamily="Courier New" fontSize="16.93333244" fontWeight="700" letterSpacing="0"  textAnchor="middle" transform="translate(-34.017857 -55.095238)" wordSpacing="0">
          <tspan x="110.62603" y="135.09752" >LOADING...</tspan>
        </text>
      </svg>
    );
  }
  //***********************
}